import React from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";
import styled from "../style.module.css";
import { GREEN, COPPER, AXIS_TICK, TOOLTIP_STYLE } from "./theme";

const DEFAULT_SERIES = [
  { key: "buy", label: "Buy", color: GREEN },
  { key: "rent", label: "Rent", color: COPPER },
];

// Horizontal stacked bars comparing two series per row (e.g. buy vs rent per title).
// `series` = [{ key, label, color }]; each `rows` item has those keys + a `name`.
const GroupedBars = ({ title, rows, nameKey, series = DEFAULT_SERIES, formatValue, emptyHint, asOf = true }) => {
  const fmt = (v) => (formatValue ? formatValue(v) : Number(v).toLocaleString());
  const data = (rows || [])
    .map((r) => {
      const o = { name: r[nameKey] };
      let total = 0;
      series.forEach((s) => {
        o[s.key] = Number(r[s.key]) || 0;
        total += o[s.key];
      });
      o.__total = total;
      return o;
    })
    .filter((d) => d.__total > 0)
    .sort((a, b) => b.__total - a.__total)
    .slice(0, 8);

  return (
    <div className={styled.chartCard}>
      <div className={styled.chartCardHead}>
        <h3 className={styled.chartTitle}>{title}</h3>
        {asOf && <span className={styled.asOfTag}>Live</span>}
      </div>
      {data.length > 0 ? (
        <ResponsiveContainer width="100%" height={Math.max(200, data.length * 40)} minWidth={0}>
          <BarChart data={data} layout="vertical" margin={{ top: 4, right: 16, bottom: 4, left: 8 }}>
            <XAxis type="number" hide />
            <YAxis type="category" dataKey="name" tick={AXIS_TICK} tickLine={false} axisLine={false} width={130} />
            <Tooltip {...TOOLTIP_STYLE} cursor={{ fill: "rgba(255,255,255,0.05)" }} formatter={(v, n) => [fmt(v), n]} />
            <Legend wrapperStyle={{ fontSize: 12, color: "rgba(255,255,255,0.7)" }} />
            {series.map((s, i) => (
              <Bar
                key={s.key}
                dataKey={s.key}
                name={s.label}
                stackId="a"
                fill={s.color}
                radius={i === series.length - 1 ? [0, 5, 5, 0] : [0, 0, 0, 0]}
                barSize={18}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <p className={styled.emptyHint}>{emptyHint || "No data yet."}</p>
      )}
    </div>
  );
};

export default GroupedBars;
